// extracted by mini-css-extract-plugin
module.exports = {"label":"idt-svginputremoveselection_label__2t2yf"};